/**
 *    @author: Andrew Sheen
 *    @since:  2021-01-28
 */

import { Component, OnInit,ElementRef,Input } from '@angular/core';

@Component({
  selector: 'a-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.less']
})
export class LinkComponent implements OnInit {

      constructor( ) { }

      @Input('link-url')    url:string;
      @Input('label-param') labelParam:Object;
      @Input('label-class') labelClass:string;
      @Input('label-style') labelStyle:string;
      @Input()              label:string;

      public ngOnInit(): void {
             if ( this.url ) {
                  this.url = this.url.trim();
             } 
      }
      
      public ngAfterViewInit() {
      }
}
